import React, { useEffect, useRef, useState } from 'react'
import styles from '../../../Pages/Common/Footer/footer.module.scss'
import {
  insuranceCompanies,
  otherRelationshipList,
  relationshipByMarriageList,
  relationshipList,
} from '../../../../constants/lists/relationshipList'
import { useDispatch, useSelector } from 'react-redux'
import { setRepresentative } from '../../../../redux/actions/careReceipients'
import {
  setPrivateIndividual,
  setRepresentativePerson,
} from '../../../../redux/actions/quizQuestions'
import ArrowBtn from '../../../../icons/arrowBtn.svg'
import { useNavigate } from 'react-router-dom'
import cx from 'classnames'
import PhoneNumberField from '../../../ReusableField/PhoneNumberField'
import { handlePhoneNumberFieldChange } from '../../../../redux/actions/Auth'
import {
  listEntryRepresentationByPrivateIndividual,
  representativeQuestions,
} from '../../../../constants/quizConstant'

const QuizRepresentative = ({ parentState, setParentState }) => {
  const {
    quizRepresentativePerson: { quizRep, indexRep },
  } = useSelector((state) => state.quizQuestions)
  const { representativePerson } = useSelector((state) => state)
  const { phoneNumberObj } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [repOption, setRepOption] = useState(false)
  const wrapperRef = useRef(null)
  const buttonGroupRefRep = useRef(null) // Move this to your component scope

  const autoUpdateQuiz =
    ((representativePerson.relationshipList === 'nicht verwandt' ||
      representativePerson.relationshipList === 'andere Verwandtschaft') &&
      (representativePerson.relationshipByMarriage ===
        'Nicht verheiratet oder verschwägert' ||
        representativePerson.relationshipByMarriage ===
          'Anders verwandt oder verschwägert')) ||
    (representativePerson.personRepresenting === 'Nein' &&
      representativePerson.commerciallyActive === 'Ja')

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setRepOption(false)
    }
  }
  useEffect(() => {}, [parentState, representativePerson.commerciallyActive])
  const handleClick = (e) => {
    const buttons = buttonGroupRefRep.current?.querySelectorAll(
      'input[type="submit"]',
    )
    buttons?.forEach((btn) => btn.classList.remove(styles.active))
    e.target.classList.add(styles.active)
    handleChange(e) // Your original handler
  }
  const handleChangeNumber = (e) => {
    if (/^\d*$/.test(e.currentTarget.value)) {
      if (e.currentTarget.value.length <= 5) {
        setParentState(e.currentTarget.value)
      }
    }
  }
  const handleChange = (e) => {
    setParentState(e.currentTarget.value)
  }
  const handleRepAnswer = () => {
    // if( representativePerson.relationship && !location.state) {
    //     navigate('/chooseData')
    //     return;
    // }
    // location.state && ( representativePerson.relationship && location.state.from === '/chooseData') && navigate('/startChallenge')
    if (!parentState) return
    const newQuiz = quizRep.map((item, i) => {
      // if( i === indexRep && item.question === 'Wie oder wo haben Sie die Vertretung gefunden?' && answerRep  && !location.state && !localStorage.getItem('accessToken')) {
      //     navigate('/chooseData')
      // }
      if (i === indexRep) {
        return {
          ...item,
          // answers:  parentState,
          answers:
            item.type === 'phoneNumber'
              ? `+${phoneNumberObj.callingCode} ` + '' + `${parentState}`
              : parentState,
          returnQuestion:
            item.question ===
              'Ist die Vertretung gewerblich als Pflegefachkraft tätig oder sogar eine Pflegefirma ?' &&
            parentState === 'Nein'
              ? 'Vertretende Person ist privat und nur gelegentlich als PflegerIn tätig.'
              : item.question ===
                    'Ist die Vertretung mit dem Antragsteller verwandt ? Bitte wählen Sie aus der Liste.' &&
                  (parentState ===
                    'Verwandt 1 Grad : Vater, Mutter, Sohn oder Tochter des Berechtigten' ||
                    parentState ===
                      'Verwandt 2. Grades: Schwester, Bruder, Grossmutter, Grossvater, Enkeltochter oder Enkelsohn des Berechtigten')
                ? 'Ersatz von Kosten der Verhinderungspflege ist bei Personen in Verwandschaft, Lebensgemeinschaft und Ehepartnern nur eingeschränkt möglich.'
                : item.question ===
                      'Ist die Vertretung mit dem Antragsteller verschwägert ? Bitte wählen Sie aus der Liste.' &&
                    (parentState === 'Ehepartner oder eingetragener Lebenspartner' ||
                      parentState ===
                        'Verschwägert 1a) Ehepartner / Lebenspartner von Vater Mutter Sohn Tochter des Berechtigten' ||
                      parentState ===
                        'Verschwägert 1b) Vater Mutter Sohn Tochter des Ehepartner / Lebenspartners des Berechtigten' ||
                      parentState ===
                        'Verschwägert 2a) Ehepartner von Schwester Bruder Grossmutter Grossvater Enkeltochter Enkelsohn des BerechtigtenVerschwägert 2b) Schwester' ||
                      parentState ===
                        'Bruder Grossmutter Grossvater Enkeltochter Enkelsohn des Ehepartnes / Lebenspartners des Berechtigten')
                  ? 'Ersatz von Kosten der Verhinderungspflege ist bei Verschwägerten Personen nur eingeschränkt möglich.'
                  : item.question ===
                        'Leben Vertretung und Antragsteller im selben Haushalt ?' &&
                      parentState === 'Ja'
                    ? 'Ersatz von Kosten der Verhinderungspflege ist bei dauernd im gleichen Haushalt lebenden Personen nur eingeschränkt möglich.'
                    : item.question ===
                          'Wie oder wo haben Sie die Vertretung gefunden?' &&
                        parentState
                      ? 'Bitte teilen Sie mir die Details zu der verrichteten Verhinderungspflege mit.'
                      : '',
        }
      }
      return item
    })

    // const filteredQuiz = (representativePerson.personRepresenting === 'Nein' && parentState === 'Ja')
    //     ? newQuiz.filter((_,i) => i !== 9 && i !== 10 && i !== 11) : representativePerson.personRepresenting === 'Ja' ?
    //       newQuiz.filter((_,i) => i !== 8 && i !== 9 && i !== 10 && i !== 11)
    //     : newQuiz
    // console.log(filteredQuiz);
    dispatch(
      setRepresentative(
        Object.keys(representativePerson)[
          representativePerson.personRepresenting === 'Nein' &&
          representativePerson.commerciallyActive === 'Ja'
            ? indexRep + 3
            : representativePerson.personRepresenting === 'Ja'
              ? indexRep + 4
              : indexRep
        ],
        Object.keys(representativePerson)[indexRep] === 'phoneNumber'
          ? `+${phoneNumberObj.callingCode} ` + '' + `${parentState}`
          : parentState,
      ),
    )
    if (indexRep < 7) {
      dispatch(setRepresentativePerson(newQuiz, indexRep + 1))
    }
    if (parentState === 'Nein' && indexRep === 7) {
      const tupdatedQuestions = [
        ...newQuiz.slice(0, 8),
        ...representativeQuestions.slice(8),
      ]
      dispatch(setRepresentativePerson(tupdatedQuestions, 8))
    }

    if (representativePerson.personRepresenting === 'Nein' && parentState === 'Ja') {
      dispatch(
        setRepresentativePerson(
          newQuiz.filter((_, i) => i !== 9 && i !== 10 && i !== 11),
          9,
        ),
      )
    }

    if (parentState === 'Ja' && indexRep === 7) {
      const tupdatedQuestions = [
        ...newQuiz.slice(0, 8), // Get the first 4 elements
        newQuiz[newQuiz.length - 1], // Get the last element
      ]
      dispatch(setRepresentativePerson(tupdatedQuestions, 8))
    }
    if (
      representativePerson.personRepresenting === 'Nein' &&
      parentState === 'Nein'
    ) {
      const tupdatedQuestions = [
        ...newQuiz.slice(0, 9),
        ...representativeQuestions.slice(9),
      ]
      dispatch(setRepresentativePerson(tupdatedQuestions, 9))
    }
    if (
      representativePerson.personRepresenting &&
      representativePerson.commerciallyActive &&
      parentState
    ) {
      dispatch(setRepresentativePerson(newQuiz, 10))
    }
    if (
      representativePerson.personRepresenting === 'Nein' &&
      representativePerson.commerciallyActive === 'Nein' &&
      parentState
    ) {
      dispatch(setRepresentativePerson(newQuiz, indexRep + 1))
    }
    if (representativePerson.personRepresenting === 'Ja' && parentState) {
      dispatch(setRepresentativePerson(newQuiz, 9))
    }

    dispatch(
      handlePhoneNumberFieldChange({
        countryCode: 'DE',
        callingCode: '49',
        number: '',
      }),
    )
    autoUpdateQuiz &&
      dispatch(
        setPrivateIndividual(
          listEntryRepresentationByPrivateIndividual.filter(
            (item) =>
              item.questionKey !== 'representingPersonByTransport' &&
              item.questionKey !== 'representingPersonByCar' &&
              item.questionKey !== 'zipCodeFrom' &&
              item.questionKey !== 'zipCodeTo' &&
              item.questionKey !== 'travelCost' &&
              item.questionKey !== 'receiptUpload' &&
              item.questionKey !== 'earningsLoss' &&
              item.questionKey !== 'amount',
          ),
          0,
        ),
      )
    setParentState('')
  }
  const clickRepOption = (e) => {
    if (!repOption) {
      setRepOption(true)
    } else {
      setRepOption(false)
    }
  }
  const clickOptionOfRep = (e) => {
    setParentState(e.target.innerText)
    setRepOption(false)
  }
  const handleChangePhone = (newPhoneNumberObj) => {
    dispatch(handlePhoneNumberFieldChange(newPhoneNumberObj))
  }
  return (
    <>
      {quizRep?.map((item, i) => {
        if (i === indexRep) {
          switch (item?.type) {
            case 'text':
              return (
                <input
                  type={'text'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && parentState) handleRepAnswer()
                  }}
                  key={i}
                  autoFocus={true}
                />
              )
            case 'number':
              return (
                <input
                  type={'text'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChangeNumber(e)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && parentState && parentState.length === 5)
                      handleRepAnswer()
                  }}
                  key={i}
                  autoFocus={true}
                />
              )
            case 'phoneNumber':
              return (
                <PhoneNumberField
                  onChange={handleChangePhone}
                  phoneNumberObj={phoneNumberObj}
                  setAnswerr={setParentState}
                  handleonKeyDown={handleRepAnswer}
                />
              )
            case 'option':
              return (
                <div className={styles.optionHid}>
                  <div
                    className={cx(styles.select, {
                      [styles.placeholder]: parentState,
                    })}
                    onClick={clickRepOption}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handleRepAnswer()
                    }}
                    key={i}
                    ref={wrapperRef}
                  >
                    {parentState ? parentState : 'Bitte wählen Sie'}
                  </div>
                  {!!repOption && (
                    <div className={styles.option}>
                      {item.question ===
                      'Ist die Vertretung mit dem Antragsteller verwandt ? Bitte wählen Sie aus der Liste.'
                        ? relationshipList.map((item) => {
                            return <div onClick={clickOptionOfRep}>{item}</div>
                          })
                        : item.question ===
                            'Ist die Vertretung mit dem Antragsteller verschwägert ? Bitte wählen Sie aus der Liste.'
                          ? relationshipByMarriageList.map((item) => {
                              return <div onClick={clickOptionOfRep}>{item}</div>
                            })
                          : otherRelationshipList.map((item) => {
                              return <div onClick={clickOptionOfRep}>{item}</div>
                            })}
                    </div>
                  )}
                </div>
              )
            case 'submit':
              return (
                <span ref={buttonGroupRefRep}>
                  <input
                    type={'submit'}
                    value={'Ja'}
                    onClick={handleClick}
                    key={i}
                    className={styles.care}
                    autoFocus={true}
                  />
                  <input
                    type={'submit'}
                    value={'Nein'}
                    onClick={handleClick}
                    key={i}
                    className={styles.care}
                  />
                </span>
              )
          }
        }
      })}
      {quizRep.length !== indexRep && (
        <button
          disabled={
            quizRep[indexRep]?.type === 'number'
              ? parentState?.length !== 5
              : !parentState
          }
          className={cx({
            [styles.btnDisabled]:
              quizRep[indexRep]?.type === 'number'
                ? parentState?.length !== 5
                : !parentState,
          })}
          onClick={handleRepAnswer}
        >
          <img src={ArrowBtn} alt={ArrowBtn} />
        </button>
      )}
    </>
  )
}
export default QuizRepresentative
